export default __webpack_public_path__ + "static/media/bg_right.dbbc7888.png";